'use client'

import { useState } from 'react'

const LINKS = [
  { href: '#home', label: 'home' },
  { href: '#about', label: 'about' },
  {
    href: 'https://secure.everyaction.com/OKb7-GmrhEGodooKWKSPZQ2',
    label: 'donate',
    external: true,
  },
]

const REGISTER_URL = 'https://iamavoter.turbovote.org/'

function BrandMark() {
  return (
    <span>
      I am a <span className="underline">voter</span>.
    </span>
  )
}

export function SiteNav() {
  const [open, setOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 border-b border-[#333] bg-black/90 backdrop-blur">
      <nav className="flex items-center justify-between px-6 py-5 md:px-12">
        <a href="#home" aria-label="I am a voter. home" className="text-[15px] font-medium text-white">
          <BrandMark />
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target={link.external ? '_blank' : undefined}
              rel={link.external ? 'noopener noreferrer' : undefined}
              className="text-[13px] tracking-[0.05em] text-[#aaa] transition-colors hover:text-white"
            >
              {link.label}
            </a>
          ))}
          <a
            href={REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white px-4 py-1.5 text-[12px] text-white transition-colors hover:bg-white hover:text-black"
          >
            register to vote
          </a>
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
          className="flex flex-col gap-1.5 p-2 md:hidden"
        >
          <span className="block h-0.5 w-6 bg-white" />
          <span className="block h-0.5 w-6 bg-white" />
          <span className="block h-0.5 w-6 bg-white" />
        </button>
      </nav>

      {open && (
        <div className="border-t border-[#333] bg-black md:hidden">
          <div className="flex flex-col gap-1 px-6 py-4">
            {LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target={link.external ? '_blank' : undefined}
                rel={link.external ? 'noopener noreferrer' : undefined}
                onClick={() => setOpen(false)}
                className="py-2 text-[15px] text-[#aaa]"
              >
                {link.label}
              </a>
            ))}
            <a
              href={REGISTER_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-2 border border-white px-4 py-3 text-center text-[13px] text-white"
            >
              register to vote
            </a>
          </div>
        </div>
      )}
    </header>
  )
}
